const PlotDetailedInformationSectionType={
	FloorPlans:'floorPlans',
	StreetViewImage:'streetViewImage',
	FrontViewImage:'frontViewImage',
	Gallery:'gallery',
	Description:'description',
	Tour:'tour',
	Video:'video'
};
export default PlotDetailedInformationSectionType;